import { render, staticRenderFns } from "./incomeHomeServiceLaborDetails.vue?vue&type=template&id=7395d145&"
import script from "./incomeHomeServiceLaborDetails.vue?vue&type=script&lang=js&"
export * from "./incomeHomeServiceLaborDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports